module.exports = __webpack_public_path__ + "img/folder-arrow-up.c91a0e15.svg";